import QuestionAggregation from "../../../../../../../models/QuestionsAggregation/QuestionAggregation";

export function getMarksTotal(state?: QuestionAggregation) {
  return state?.get("marksTotal");
}

export function getAverageMark(state?: QuestionAggregation) {
  return state?.get("averageMark");
}
